import LicenceBillingCSP from "../../models/csp/LicenceBillingCSP";
import service from "../service";
import baseEndpointPartnerCenter from "./servicePartnerCenter";

export default {
  components: { service: service },
  methods: {
    async getLicencesBillingsCSP(
      customerId: string
    ): Promise<LicenceBillingCSP[]> {
      const response = await service.methods.getEndpointAsync(
        `${baseEndpointPartnerCenter}/customers/${customerId}/servicecosts/mostrecent/lineitems`
      );
      return response.items.map(
        lb =>
          new LicenceBillingCSP({
            unitPrice: lb.unitPrice,
            subscriptionId: lb.subscriptionId
          })
      );
    }
  }
};
